import ReactMarkdown from 'react-markdown';
import rehypeSanitize from 'rehype-sanitize';
import remarkGfm from 'remark-gfm';
import { cn } from '@/shared/lib/utils';

type MarkdownProps = {
  /** Markdownコンテンツ */
  children: string;
  /** 追加のCSSクラス名 */
  className?: string;
  /** Tailwind Typographyの`prose`クラスを使用するか */
  useProse?: boolean;
};

/**
 * XSS対策済みMarkdownレンダリングコンポーネント
 *
 * rehype-sanitizeプラグインを使用してMarkdownコンテンツをサニタイゼーションします。
 * 外部から取得したMarkdownを安全にレンダリングできます。
 *
 * @example
 * ```tsx
 * <Markdown>{aiResponse}</Markdown>
 * ```
 */
export const Markdown = ({ children, className, useProse = true }: MarkdownProps) => {
  return (
    <div
      className={cn(
        'text-sm text-text-base leading-relaxed',
        useProse &&
          [
            'prose prose-stone max-w-none',
            'prose-headings:font-semibold prose-headings:text-text-base',
            'prose-h1:mt-0 prose-h1:mb-4',
            'prose-h2:mt-6 prose-h2:mb-2',
            'prose-hr:my-2',
            'prose-li:my-1 prose-p:my-2 prose-ul:my-2 prose-ol:list-decimal prose-ul:list-disc',
            'prose-table:my-1 prose-table:border prose-table:border-border',
            'prose-td:border prose-th:border prose-td:border-border prose-th:border-border',
            'prose-td:px-2 prose-th:px-2 prose-td:py-1.5 prose-th:py-1.5',
          ].join(' '),
        className,
      )}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeSanitize]}>
        {children}
      </ReactMarkdown>
    </div>
  );
};
